import React from 'react';

const RotatingRisquiKey = ({rotation}) => {

  return (
    <div id="login-key"  style={{"transform": "rotateZ("+rotation+"deg)"}}>
      <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"  x="0px" y="0px" viewBox="0 0 346 388" >        
          <path d="M345.3 321.6L304.1 264.6L279.8 282.2L232.7 217C253.2 194.3 265.7 164.7 265.7 132.6C265.7 58.2 207.5 0 132.2 0C59.6 0 0 59.1 0 130.8C0 203 59.6 261.6 132.6 261.6C150.6 261.6 167.9 258 183.6 251.5L273 375.3C282.7 388.7 301.5 391.8 314.9 382C328.3 372.3 331.4 353.5 321.6 340.1L320.3 338.3L320.8 339L345.3 321.6ZM60.4 129.9C60.4 88.8 93.3 55 132.6 55C172.7 55 205.2 89.3 205.2 130.8C205.2 172.8 172.7 206.6 133 206.6C92.5 206.6 60.4 172.8 60.4 129.9Z" fill="#001752" />
      </svg>
    </div>
  );
};

export default RotatingRisquiKey;